<template>
    <div class="pageFeed1">
        <div class=" mb16" v-if="isDisplay==true">
            <div class="form-column">
                <select v-model="pageFeedData.pageSize" @change="search" size="1">
                    <option v-for="(option, index) in dispPageSizeList" :key=index :value="option.value">{{option.text}}</option>
                </select>
                <slot name="othersButton"></slot>
            </div>
        </div>
        <slot name="TableRender"></slot>
        <ul class="pager fs mb64">
            <li v-for="(page, index) in Math.ceil(pageFeedData.totalRecord/pageFeedData.pageSize)" :key=index><font style='color:#0e0e0e; cursor: pointer;' @click="changePageNo(page)">{{page}}</font></li>
        </ul>
    </div>
</template>

<script>
import InputCheck from 'components/InputCheck';
/* 
* Import libs and componnents
*/
export default {
    /* 
    * Name of component
    */
    name: "PageFeed1",
    /* 
    * Declare components
    */
    components: {
        InputCheck
    },
    props: {
        pageFeedData: {
            type: Object
        },
        orderByType: {
            type: [Number, String]
        },
        dispPageSizeList: {
            type: Array,
            default: function() {
                return [
                    {value: 16,text: "16件"},
                    {value: 10,text: "10件"},
                    {value: 20,text: "20件"},
                    {value: 30,text: "30件"},
                    {value: 40,text: "40件"},
                    {value: 50,text: "50件"}
                ]
            }
        },
        dispSortList: {
            type: Array,
            default: function() {
                return [
                    {"key": "1", "value": "登録日が新しい"},
                    {"key": "4", "value": "登録日が古い"},
                    {"key": "3", "value": "価格が高い"},
                    {"key": "2", "value": "価格が安い"}
                ]
            }
        },
        isDispSort: {
            type: Boolean,
            default: true
        },
        isDisplay:{
            type: Boolean,
            default: true
        },
        isDisplaySort:{
            type: Boolean,
            default: true
        }
    },
    /* 
    * Declare variable and set default value
    */
    data() {
        return {
            selectedDispSortNo: this.orderByType != undefined ? this.orderByType : 1,
            goto: null
        }
    },
    /* 
    * Methods
    */
    methods: {
        search: function() {
            this.$emit('search', this.selectedDispSortNo, this.pageFeedData.pageSize, 1);
        },
        changeDispSortNo: function() {
            this.$emit('changeDispSortNo', this.selectedDispSortNo)
        },
        changePageSize: function() {
            this.$emit('changePageSize', this.pageFeedData.pageSize)
        },
        changePageNo: function(pageNo) {
            this.$emit('search', this.selectedDispSortNo, this.pageFeedData.pageSize, pageNo);
        },
        firstPage() {
            this.pageFeedData.pageNo = 1;
            this.changePageNo();
        },
        previousPage() {
            this.pageFeedData.pageNo > 1 ? this.pageFeedData.pageNo-- : this.pageFeedData.pageNo = 1;
            this.changePageNo();
        },
        nextPage() {
            var totalPage = Math.ceil(this.pageFeedData.totalRecord/this.pageFeedData.pageSize);
            this.pageFeedData.pageNo < totalPage ? this.pageFeedData.pageNo++ : this.pageFeedData.pageNo = totalPage;
            this.changePageNo();
        },
        lastPage() {
            var totalPage = Math.ceil(this.pageFeedData.totalRecord/this.pageFeedData.pageSize);
            this.pageFeedData.pageNo = totalPage;
            this.changePageNo();
        },
        gotoPage() {
            if(this.goto == null || this.goto == "") return;
            var totalPage = Math.ceil(this.pageFeedData.totalRecord/this.pageFeedData.pageSize);
            Number(this.goto) > totalPage ? this.pageFeedData.pageNo = totalPage : this.pageFeedData.pageNo = Number(this.goto);
            this.goto = null;
            this.changePageNo();
        }
    }
}
</script>

<style scoped>
.pageFeed1 {
    font-size:13px
}
.pageFeed1 .seach-style {
    border:1px solid #AAAAAA;
    width:312px;
}
.pageFeed1 .seach-header-style {
    width:310px;
    background:#CCCCFF;
}
.pageFeed1 .goto-style{
    width:30px;
    text-align:right;
    border: 1px solid #A9A9A9;
}
</style>
